// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6Lo0x","input":"styles_input__1l7aT"};